import { Component, effect, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Operator } from 'src/app/bo/operator';
import { OperatorRoles } from 'src/app/bo/operatorRoles';
import { ProprieteAffichee } from 'src/app/bo/proprieteAffichee';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { OperateursModaleComponent } from '../operateurs-modale/operateurs-modale.component';

@Component({
  selector: 'app-operateurs',
  templateUrl: './operateurs.component.html',
  styleUrls: ['./operateurs.component.scss'],
  standalone: false
})
export class OperateursComponent {
  modale = signal<BsModalRef>(null);
  modaleAjout = signal<BsModalRef>(null);
  tabOperateur = signal<Operator[]>([]);
  proprietesAffichees = signal<ProprieteAffichee[]>([]);
  erreurRecuperation = signal<boolean>(false);

  constructor(private readonly modalService: BsModalService, private readonly http: HttpService, private readonly fonctionsService: FonctionsService,
    private readonly translate: TranslateService, private readonly utilService: UtilisateurService) {
    this.proprietesAffichees.set(new Operator().getProprietesAffichees());
    effect(() => { this.utilService.currentSite(); this.refreshData(); });
  }


  ouvrirModale(op: Operator) {
    this.fonctionsService.loading_screen(true);
    this.http.get<Operator>('Sites/' + this.utilService.currentSite().siteId + '/Operator/' + op.operatorId).subscribe(zone => {

      var initialState = {
        operator: signal(op),
        estModif: signal(true),
        siteId: signal(this.utilService.currentSite().siteId),
        selectedRoles: signal(op.roles.map(role => OperatorRoles[role] ? OperatorRoles[role].toString() : ''))
      };


      this.fonctionsService.loading_screen(false);
      this.modale.set(this.modalService.show(OperateursModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState }));
      this.modale().content.modaleFermee.subscribe(success => {
        if (success)
          this.refreshData();
        this.fonctionsService.launch_toast(success);
      });

    }, () => {
      this.translate.get('GLOBAL.ERREUR_RECUP_DONNEES').subscribe(trad => {
        this.fonctionsService.launch_toast(false, false, trad)
      });
      this.fonctionsService.loading_screen(false);
    });
  }

  ouvrirModaleAjout() {
    var initialState = {
      estModif: signal(false),
      siteId: signal(this.utilService.currentSite().siteId)
    };
    this.modale.set(this.modalService.show(OperateursModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState }));
    this.modale().content.modaleFermee.subscribe(success => {
      if (success)
        this.refreshData();
      this.fonctionsService.launch_toast(success);
    });
  }

  private refreshData() {
    this.erreurRecuperation.set(false);

    var startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);

    this.http.get<Operator[]>('Sites/' + this.utilService.currentSite().siteId + '/Operators').subscribe(resultat => {
      this.tabOperateur.set(resultat);
      this.tabOperateur().forEach(op => {
      op.rolesAffichees = op.roles
        .map(role => {
          if (OperatorRoles[role] !== undefined) {
            return this.translate.instant('OPERATOR_ROLE.' + OperatorRoles[role]);
          }
          return '';
        })
        .filter(roleText => roleText !== '')
        .join(', ');
    });

      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
    }, () => {
      this.erreurRecuperation.set(true);
      this.fonctionsService.loading_screen(false);
      clearTimeout(startLoader);
    });
  }

}
